export function isPublishedFindingVisibleToCustomers(finding: {
  isPublished: boolean | null;
  status: string;
}): boolean {
  return !!finding.isPublished;
}
